var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.team.length
    ? _c(
        "my-carousel",
        {
          attrs: {
            "per-page-custom": _vm.perPage,
            "scroll-per-page": true,
            "pagination-enabled": false,
            "navigation-enabled": true,
            "navigation-next-label": "<span></span>",
            "navigation-prev-label": "<span></span>"
          }
        },
        _vm._l(_vm.team, function(member, index) {
          return _c("slide", { key: index }, [
            _c("div", { staticClass: "agency-team-slide" }, [
              _c("img", {
                staticClass: "avatar",
                attrs: { src: member.url, alt: "" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(member.nominative) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "role" }, [
                _vm._v(
                  "\n                " + _vm._s(member.role) + "\n            "
                )
              ])
            ])
          ])
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }